import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import './Header.css'

const Header = () => {
    const location = useLocation();
    const isTerms = location.pathname === "/terms" || location.pathname === "/";
    const isPrivacy = location.pathname === "/privacy";

    return (
        <header>
            <div className='header-section'>
                <Link to='/' className='header-logo'>
                    <span>Widgets</span>
                </Link>

                <div className='header-items'>
                    <Link 
                        to='/terms' 
                        className={isTerms ? 'active-link' : ''}
                    >
                        Terms & Conditions
                    </Link>
                    <Link 
                        to='/privacy' 
                        className={isPrivacy ? 'active-link' : ''}
                    >
                        Privacy Policy
                    </Link>
                </div>
            </div>
        </header>
    )
}

export default Header